import React from "react";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../utility/general";

function PatientsTable({ data }) {
  const navigate = useNavigate();

  // Filter accepted appointments
  const acceptedAppointments =
    data?.filter((row) => row.status?.toLowerCase() === "accepted") || [];

  if (!acceptedAppointments || acceptedAppointments.length === 0) {
    return (
      <div className="w-100">
        <div
          className="w-100 none-flex-item m-t-40"
          style={{ padding: "20px", textAlign: "center" }}
        >
          <h4 style={{ fontSize: "clamp(0.9rem, 3vw, 1.1rem)" }}>
            No accepted appointments found
          </h4>
        </div>
      </div>
    );
  }

  return (
    <div className="w-100">
      <div
        className="w-100 none-flex-item m-t-40"
        style={{
          overflowX: "auto",
          WebkitOverflowScrolling: "touch",
          maxWidth: "100%",
        }}
      >
        <table
          className="bordered-table"
          style={{ minWidth: "700px", width: "100%" }}
        >
          <thead className="border-top-none">
            <tr className="border-top-none">
              <th
                style={{
                  whiteSpace: "nowrap",
                  padding: "8px 12px",
                  fontSize: "clamp(0.75rem, 2.5vw, 0.9rem)",
                }}
              >
                #
              </th>
              <th
                style={{
                  whiteSpace: "nowrap",
                  padding: "8px 12px",
                  fontSize: "clamp(0.75rem, 2.5vw, 0.9rem)",
                }}
              >
                Patient Name
              </th>
              <th
                style={{
                  whiteSpace: "nowrap",
                  padding: "8px 12px",
                  fontSize: "clamp(0.75rem, 2.5vw, 0.9rem)",
                }}
              >
                Appointment Date
              </th>
              <th
                style={{
                  whiteSpace: "nowrap",
                  padding: "8px 12px",
                  fontSize: "clamp(0.75rem, 2.5vw, 0.9rem)",
                }}
              >
                Time
              </th>
              <th
                style={{
                  whiteSpace: "nowrap",
                  padding: "8px 12px",
                  fontSize: "clamp(0.75rem, 2.5vw, 0.9rem)",
                }}
              >
                Status
              </th>
              <th
                style={{
                  whiteSpace: "nowrap",
                  padding: "8px 12px",
                  fontSize: "clamp(0.75rem, 2.5vw, 0.9rem)",
                }}
              >
                Description
              </th>
              <th
                style={{
                  whiteSpace: "nowrap",
                  padding: "8px 12px",
                  fontSize: "clamp(0.75rem, 2.5vw, 0.9rem)",
                }}
              >
                Tracking
              </th>
            </tr>
          </thead>

          <tbody className="white-bg view-det-pane">
            {acceptedAppointments.map((row, index) => {
              const status = row.isCanceled
                ? "Cancelled"
                : row.isDischarged
                  ? "Discharged"
                  : row.isAdmitted
                    ? "Admitted"
                    : "Scheduled";

              const statusClass = row.isCanceled
                ? "text-danger"
                : row.isDischarged
                  ? "text-success"
                  : row.isAdmitted
                    ? "text-warning"
                    : "text-primary";

              return (
                <tr
                  key={index}
                  className="pointer"
                  onClick={() => {
                    localStorage.setItem("appointmentId", row.id);
                    navigate(`/patients/patient-details/${row.patientId}`);
                  }}
                >
                  <td
                    style={{
                      padding: "8px 12px",
                      fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                    }}
                  >
                    {index + 1}
                  </td>
                  <td
                    style={{
                      padding: "8px 12px",
                      fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {row.patientName}
                  </td>
                  <td
                    style={{
                      padding: "8px 12px",
                      fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {row.appointDate}
                  </td>
                  <td
                    style={{
                      padding: "8px 12px",
                      fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {row.appointTime}
                  </td>
                  <td
                    className={statusClass}
                    style={{
                      padding: "8px 12px",
                      fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                    }}
                  >
                    {row?.status}
                  </td>
                  <td
                    style={{
                      padding: "8px 12px",
                      fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                      maxWidth: "150px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {row.description || "No description"}
                  </td>
                  <td
                    style={{
                      padding: "8px 12px",
                      fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                    }}
                  >
                    {row.tracking}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default PatientsTable;
